<template>
	<div class="section-toggle">
		<div class="title flex" @click="toggle" v-if="!giftcard">
			<slot name="title" />
			<i class="fas fa-chevron-right" :class="{ 'triggered': trigger }" v-if="!giftcard"></i>
		</div>
		<div class="flex flex-vcenter justify-content-center"  @click="toggle" v-else>
			<slot name="gift">
				<b class="mb-2 pr-2" style="font-size: 13px; color: var(--quomi-color-text)">Prodotti</b>
				<i class="fas fa-chevron-right mb-2" :class="{ 'triggered': trigger }"></i>	
			</slot>
		</div>
		
		<div class="info" v-if="trigger || lastOrder">
			<slot name="content" />
		</div>
	</div>
</template>

<script>
export default {
	data () {
		return {
			
		}
	},

	props: {
		trigger: {
			type: Boolean,
			default: false
		},
		lastOrder: {
			type: Boolean,
			default: false
		},
		giftcard: {
			type: Boolean,
			default: false
		}
	},

	methods: {
		toggle () {
			this.$emit('update:trigger', !this.trigger)
			
		}
	}
}
</script>

<style scoped>

/*.info.collapsed {
  max-height:9999px;
  
}*/

.info {
  transition:all .7s ease;
}

.title {
	position: relative;
	align-items: center;
	cursor: pointer;
	justify-content: space-between;
	align-items: center;
}

.fas {
	transition: ease 0.5s all;
	margin: 0 4px;
}

.triggered {
	transform: rotate(90deg);
}
</style>
